export enum CRUDOperationsEnum {
  CREATE = 'create',
  READ = 'read',
  LIST = 'list',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum ACLOperationsEnum {
  WRITE = 'write',
  READ = 'read',
}
